import { Linkedin, Instagram, Facebook, Youtube } from "lucide-react";
import { site } from "@/data/site";
import { IDS } from "@/constants/testIds";

const columns = [
  {
    title: "Company",
    links: [
      { label: "About", href: "#about" },
      { label: "Products", href: "#products" },
      { label: "Industries", href: "#industries" },
      { label: "Export Process", href: "#process" },
      { label: "FAQ", href: "#faq" },
      { label: "Contact", href: "#contact" },
    ],
  },
  {
    title: "Products",
    links: [
      { label: "Paper Cups", href: "#products" },
      { label: "Paper Bags", href: "#products" },
      { label: "Compostable Packaging", href: "#products" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Catalogue", href: "#products" },
      { label: "Export Process", href: "#process" },
      { label: "FAQ", href: "#faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative bg-forest text-sage overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid lg:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center justify-center rounded-full bg-white p-1.5 shadow-lg">
                <img src={site.brand.logo} alt={site.brand.name} className="h-16 w-16 sm:h-20 sm:w-20 object-contain" />
              </span>
              <div>
                <div className="font-heading text-2xl tracking-tight leading-none text-white">
                  Ashrita Overseas
                </div>
                <div className="text-sm italic text-sage/80 mt-2 max-w-xs">
                  Protecting the Earth through sustainable solutions.
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm text-sage/60 leading-relaxed max-w-sm">
              We source and export premium eco-friendly paper and biodegradable
              packaging products from India, helping importers, wholesalers,
              distributors, retailers, and global brands build a more
              sustainable future.
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <div className="text-xs uppercase tracking-[0.2em] font-semibold text-white">
                {col.title}
              </div>
              <ul className="mt-4 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-sage/70 hover:text-white transition-colors inline-flex items-center gap-1"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Connect */}
          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-white">
              Connect
            </div>
            <ul className="mt-4 space-y-3">
              {[
                { name: "Instagram", href: site.social.instagram, Icon: Instagram, testid: "footer-instagram" },
                { name: "Facebook", href: site.social.facebook, Icon: Facebook, testid: "footer-facebook" },
                { name: "YouTube", href: site.social.youtube, Icon: Youtube, testid: "footer-youtube" },
                { name: "LinkedIn", href: site.social.linkedin, Icon: Linkedin, testid: IDS.footerLinkedin },
              ].map((s) => (
                <li key={s.name}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={s.testid}
                    aria-label={s.name}
                    className="group inline-flex items-center gap-2.5 text-sm text-sage/70 hover:text-white transition-colors"
                  >
                    <s.Icon className="h-4 w-4 text-sage group-hover:text-white transition-colors" />
                    {s.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-sage/50">
            © 2026 {site.brand.name}. All Rights Reserved.
          </p>
          <p className="text-xs text-sage/40">
            Merchant Exporter · Sustainable Packaging · India
          </p>
        </div>
      </div>

      {/* Massive watermark */}
      <div
        aria-hidden="true"
        className="pointer-events-none select-none relative -mt-2 overflow-hidden"
      >
        <div className="font-heading font-bold text-white/[0.06] text-[18vw] leading-[0.8] tracking-tight text-center whitespace-nowrap translate-y-[18%]">
          ASHRITA
        </div>
      </div>
    </footer>
  );
}
